module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e3f95aa","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vue-cleave/src/Cleave.vue
// module id = 1046
// module chunks = 0